import {createSinglePathSVG} from './TEMPLATE'

export const Newspaper2_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M15 18h-5M18 14h-8M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2M11 6h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
})
